import { render, staticRenderFns } from "./trueh5Config.vue?vue&type=template&id=445b85fd&scoped=true"
import script from "./trueh5Config.vue?vue&type=script&lang=ts"
export * from "./trueh5Config.vue?vue&type=script&lang=ts"
import style0 from "./trueh5Config.vue?vue&type=style&index=0&id=445b85fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445b85fd",
  null
  
)

export default component.exports